import { toast } from "react-toastify";
import ApiService from "../../../services/apiService";
import { useCallback, useState } from "react";
import { usePagination } from "../../../hooks/usePagination";
import { Button, Card, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import LoadingComponent from "../../lodingComponent";
import Table from "../../table/Table";
import FilterIcon from "../../svg/FilterIcon";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { Filter } from "react-feather";



const WuaList =() =>{

    const role = useAppSelector((state) => state.role.role);
    const [waterChargesData,setWaterChargesData] = useState()
    const [isDeleteModalOpen,setIsDeleteModalOpen] = useState<boolean>(false)
    const[selectedWaterChargeId,setSelectedWaterChargeId] = useState<any>()

    const navigate = useNavigate()

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy,
        loading
    } = usePagination({
        endpoint: `/wua`,
      
        enabled:true
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])


   

    const handleUpdate = (id: string) => {
        navigate(`/update-wua/${id}`);
    }

    const handleDelete = (id: string) => {
        setSelectedWaterChargeId(id);
        setIsDeleteModalOpen(true);
    }

    const handleDeleteWaterCharge = async (id: string) => {
        try {
            console.log(id);
            const response = await ApiService.axiosApi(`/wua/${id}`, {
                method: 'DELETE',
            });

            if (response.success) {
                
                toast.success('Deleted Successfully');
                setIsDeleteModalOpen(false);
                setRefresh(prev => !prev);
            }
            else {
                toast.error(response.data.message);
            }
        } catch (error: any) {
            toast.error(error.message);
        }
    }
   
     
    return(
          <>
             <Breadcrumbs mainTitle={'Wua'} parent={'Configuration'} />
            
            <Card>
                <CommonCardHeader title="Wua" headClass={"pb-3"} />
                <div className="d-flex justify-content-between">
                <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                    <div>
                    <input 
                   type="text" 
                   className="search-input"
                   placeholder="...search"
                   value={searchQuery}
                   onChange={(e)=>{setSearchQuery(e.target.value)
                       setPageNumber(1)
                   }}
                  
                    />
                    </div>
                       <div>
                       <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('Scheme_Village')}>
                       <Filter />
                   </button>
                       </div>
                    
                </div>
                {role === "Administrator" && (
                    <div className="d-flex justify-content-end">
                        <Button onClick={() => navigate(`/add-wua`)} color="primary" className="mb-2 mx-2">Add Wua</Button>
                    </div>
                )}
                 </div>
                 {loading?<LoadingComponent/>:<Table
                    data={data}
                    columns={[
                        { header: "Wua Leader", accessor:"headQuaterName" },
                     
                    ]}

                    buttons={[
                        { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
                        { label: "Delete", onClick: handleDelete, color: "danger" }
                    ]}
                />}
                
                <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                    <p style={{ marginRight: '10px', marginTop: '8px' }}>
                        Page {pageNumber} of {totalPages}
                    </p>
                    <button
                        onClick={handlePrev}
                        disabled={pageNumber === 1}
                        className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                    >
                        <LeftIcon className="icon" />
                    </button>
                    <button
                        className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        onClick={handleNext}
                        disabled={pageNumber === totalPages}
                    >
                        <RightIcon className="icon" />
                    </button>
                </div>
            </Card>

            <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                <ModalHeader>Delete Scheme Village</ModalHeader>
                <ModalBody>Are you sure you want to delete this wua?</ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => handleDeleteWaterCharge(selectedWaterChargeId)}>Delete</Button>
                    <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>
          </>
    )
}

export default WuaList;